import React from 'react';
import { Link } from 'gatsby';
import { connectHits } from 'react-instantsearch-dom';

const Hit = ({ slug, title, serviceRef, type, articleIntro, listingIntro }) => {
  // update path depending on type
  const path = type === 'project' ? 'projects' : 'news';

  return (
    <div className='pb-10 border-b border-[#6C6C6C]/30 flex flex-col gap-y-3'>
      <span className='blockH6 text-green'>{title}</span>
      <p className='blockH8 text-blue'>
        {serviceRef?.title || articleIntro || listingIntro}
      </p>
      <Link
        to={`/${path}/${slug?.current}`}
        className='blockH9 text-blue underline underline-offset-2'>
        READ MORE
      </Link>
    </div>
  );
};

const Hits = ({ hits }) => {
  return (
    <div className='mt-16 md:mt-32 flex flex-col gap-y-10  '>
      {hits?.map((hit) => (
        <Hit {...hit} />
      ))}
      {hits.length === 0 && (
        <div className='col-start-2 col-end-3 text-center'>
          <h1 className='blockH4 mb-10 text-blue'>No results found</h1>
        </div>
      )}
    </div>
  );
};

export const SearchHits = connectHits(Hits);
